import {STORE_WORDGROUPS} from "../_CONSTANTS";

export const storeWordGroups = (analysisId, wordGroups) => {
  return ({
    type: STORE_WORDGROUPS,
    payload: {analysisId, wordGroups}
  })
}

